module.exports = __webpack_public_path__ + "assets/d387d8d5069e3519b7d19557ebb15bc1.mp3";